import type { SVGProps } from "react";
const SvgJava = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 256 256"
    {...props}
  >
    <rect width="100%" height="100%" fill="#fff" />
    <path
      fill="#5382A1"
      d="M98.972 189s-8.722 4.573 6.207 6.12c18.087 1.861 27.331 1.594 47.262-1.807 0 0 5.241 2.962 12.559 5.528-44.682 17.265-101.123-1-66.028-9.841M94.03 165s-9.58 6.66 5.051 8.082c18.921 1.833 33.863 1.983 59.719-2.693 0 0 3.577 3.405 9.2 5.267-52.905 14.53-111.831 1.146-73.97-10.656"
    />
    <path
      fill="#F8981D"
      d="M137.115 121.919c11.028 12.149-2.898 23.081-2.898 23.081s28.002-13.831 15.142-31.152C137.348 97.696 128.138 89.671 178 62c0 0-78.267 18.704-40.885 59.919"
    />
    <path
      fill="#5382A1"
      d="M195.746 205.909s6.239 5.258-6.872 9.326c-24.931 7.725-103.764 10.058-125.663.308-7.873-3.503 6.89-8.364 11.534-9.384 4.843-1.074 7.61-.874 7.61-.874-8.754-6.309-56.587 12.386-24.296 17.74 88.062 14.608 160.529-6.577 137.687-17.116M103.798 138.041s-40.157 10.791-14.221 14.709c10.951 1.659 32.782 1.284 53.117-.644 16.619-1.586 33.306-4.958 33.306-4.958s-5.86 2.839-10.1 6.114c-40.778 12.134-119.555 6.489-96.876-5.922 19.18-10.489 34.774-9.299 34.774-9.299M175.83 179.877c41.319-22.291 22.215-43.712 8.881-40.826-3.269.706-4.726 1.318-4.726 1.318s1.213-1.973 3.531-2.827c26.379-9.629 46.667 28.397-8.516 43.458 0 0 .639-.593.83-1.123"
    />
    <path
      fill="#F8981D"
      d="M151.003 18s23.375 22.735-22.17 57.696c-36.523 28.044-8.329 44.035-.016 62.304-21.318-18.702-36.963-35.166-26.467-50.488C117.755 65.019 160.434 54.113 151.003 18"
    />
    <path
      fill="#5382A1"
      d="M107.336 237.336C147.252 239.77 208.548 235.986 210 218c0 0-2.791 6.819-32.989 12.233-34.069 6.106-76.089 5.393-101.011 1.48 0 0 5.102 4.021 31.336 5.623"
    />
  </svg>
);
export default SvgJava;
